







import Vue from 'vue';
import Component from 'vue-class-component';
import { PageTitle } from '@questelservices/common-vue';
import UserAssignedClients from '../components/users/user-assigned-clients.vue';

@Component({
  components: {
    PageTitle,
    UserAssignedClients
  }
})
export default class UserAssigned extends Vue {}
